// extracted by mini-css-extract-plugin
module.exports = {"layout":"PrimaryLayout_layout__ltape","content":"PrimaryLayout_content__O9jOT"};